declare namespace $ {

	export class $shm_hitalama_benchmarks_client_frame extends $mol_view {
		client( ): $shm_hitalama_benchmarks_client
		dom_name( ): string
		uri( ): string
		sub( ): readonly(any)[]
		attr( ): ({ 
			'src': ReturnType< $shm_hitalama_benchmarks_client_frame['uri'] >,
		})  & ReturnType< $mol_view['attr'] >
		minimal_height( ): number
		style( ): ({ 
			'width': string,
			'height': string,
		})  & ReturnType< $mol_view['style'] >
	}
	
}

//# sourceMappingURL=frame.view.tree.d.ts.map